import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

import * as Styled from './NotificationIcon.styled';

/**
 * Displays an icon with a badge indicating a count
 */
const NotificationIcon = ({ name, count, onClick, ...props }) => (
  <Styled.NotificationIcon onClick={onClick} {...props}>
    <Icon name={name} size={22} />
    {!!count && <Styled.Badge fill="var(--brand-soft-blue)" count={count} />}
  </Styled.NotificationIcon>
);

NotificationIcon.propTypes = {
  /**
   * name of the icon to display
   */
  name: PropTypes.string.isRequired,
  /**
   * number of notifications to display
   */
  count: PropTypes.number,
  /**
   * Handler for optional click event
   */
  onClick: PropTypes.func
};

NotificationIcon.defaultProps = {
  count: 0,
  onClick: undefined
};

export default NotificationIcon;
